//@ts-ignore
//@ts-ignore
import React from 'react';
import classNames from 'classnames';
import { useEffect, useState } from 'react';

import { ButtonBg } from './ButtonBg';
import LeftMenuNav from './LeftMenuNav';
import MenuNav from './MenuNav';
import {
  AddressBoxStyle,
  ButtonCommonStyle,
  CloseButtonStyle,
  MenuGeaderStyle,
  NavStyle,
  SearchButtonStyle,
  SearchInputStyle,
} from './styles';
import { TBurgerMenuProps, TMenuObject, TMenuType, TourMode } from './types';
import { useLoadModel } from 'src/hooks/useLoadModel';
import ThreeInstance from 'src/sdk-components/ThreeInstance';
import { MenuType } from '../types';
import { ExternalPopup } from '../popups/external-popup';
import { Panorama } from '../panorama';
import { Box, Link, Stack, TextField, Typography } from 'src/components/mui';
import { Icon } from '../icon/Icon';
import { filterMenuItems } from './utils';

export const BurgerMenu = ({
  bookUrl,
  bookText,
  buttonColors,
  menuColors,
  menuSearch,
  translation,
  bookAppointment,
  contact,
  address,
  whitelabel,
  menuOpen,
  rtl = false,
  isHorizontalMobileView,
  inputSearchRef,
  openOnHover,
  toggleAppointmentsModal,
  toggleContactPopup,
  toggleAddressPopup,
  menus,
  menuRef,
  chatToken,
  tour,
  host,
  menuOpenForDevice,
  tourType,
  MenuHintOn,
  tourEmail,
  showCustomButton,
  getInTouchHintOn,
  appointmentsHintOn,
  handleCustomButton,
  menuOpened,
  menu,
  showcase,
  publicSweeps,
  fromAdmin,
  windowWidth,
  panoramas,
  awsUrl,
  tags,
}: TBurgerMenuProps) => {
  const { menuOnStart } = menu;
  const [menuState, setMenuState] = useState({
    menus: [],
    originMenus: [],
    scrollTo: 0,
    menuOpen: false,
    menuOpened: false,
    menuOnStart: false,
    MenuHintOn: false,
  });

  const [mpFloors, setMpFloors] = useState([] as any);
  const [mpLabels, setMpLables] = useState([] as any);

  const [sweeps, setSweeps] = useState([] as any);
  const { loadModel, setPanorama, tourPlaying, popUp, toggleExternalPopup, panorama } =
    useLoadModel(showcase, publicSweeps, tags);

  useEffect(() => {
    setMenuState((prevState) => ({
      ...prevState,
      menus: menus,
      originMenus: menus,
      menuOpen: menuOpen,
      menuOpened: menuOpened,
      menuOnStart: menuOnStart,
      MenuHintOn: MenuHintOn,
    }));
  }, [menus, menuOpen, menuOpened, menuOnStart, MenuHintOn]);

  const resetMenus = (menus: TMenuType[]) => {
    menus.map((m: TMenuType) => {
      m.open = false;
      if (m.subMenus) {
        m.subMenus = m.subMenus.map((sM: TMenuType) => {
          sM.open = false;
          return sM;
        });
      }
      return m;
    });
  };

  const openMenu = (i: number, j: number | null = null) => {
    let scrollTo = (i + 1) * 33;

    let menu = menus[i];
    if (!menu) {
      resetMenus(menus);

      return;
    }
    if (j != null) {
      menu = menu.subMenus[j];
      scrollTo += (j + 1) * 33;
    }

    if (isHorizontalMobileView) {
      resetMenus(menus);
      if (menu.subMenuId) {
        const parent = menus.subMenus.find(({ id }: { id: number }) => id === menu.subMenuId);
        if (parent) parent.open = !parent.open;
      }
      if (menu.menuId) {
        const parent = menus.find(({ id }: { id: number }) => id === menu.menuId);
        if (parent) parent.open = !parent.open;
      }
    }
    menu.open = !menu.open;
    setMenuState((prevState) => ({ ...prevState, menus, scrollTo }));
  };

  useEffect(() => {
    if (showcase) {
      showcase.Floor.data.subscribe({
        //Get floor data
        onCollectionUpdated: (collection: any) => {
          const mpFloors: any = [];
          Object.keys(collection).map((o) => {
            const floor = collection[o];
            if (!floor.name || floor.name.length === 0) return;
            mpFloors.push(floor);
          });
          setMpFloors(mpFloors);
        },
      });

      showcase.Label.getData()
        .then((labels) => {
          setMpLables(labels);
        })
        .catch(() => console.error('Error to load MP labels'));

      showcase.Sweep.data.subscribe({
        onCollectionUpdated: (collection) => {
          const transformToUUID = (id) =>
            id.slice(0, 8) +
            '-' +
            id.slice(8, 12) +
            '-' +
            id.slice(12, 16) +
            '-' +
            id.slice(16, 20) +
            '-' +
            id.slice(20);
          const sweeps = Object.values(collection).map((item: any) => ({
            ...item,
            // eslint-disable-next-line @typescript-eslint/dot-notation
            sweep_uuid: transformToUUID(item['id']),
            floor_index: Number(item.floorInfo.id),
            floor_position: item.position,
          }));

          setSweeps(
            sweeps,
            // this.afterSweepsInit
          );
        },
      });
    }
  }, [showcase]);

  const changeViewMode = async (mode: TourMode) => {
    try {
      setPanorama((prevState) => ({ ...prevState, panoramaOn: false }));
      if (tourPlaying) {
        await showcase.Tour.stop();
      }
      await showcase.Mode.moveTo(mode);
    } catch (err) {
      console.error(err);
    }
  };

  const changeFloor = async (floorIndex: number, all = false) => {
    try {
      setPanorama((prevState) => ({ ...prevState, panoramaOn: false }));
      if (tourPlaying) {
        await showcase.Tour.stop();
      }

      if (all) {
        await showcase.Floor.showAll();
      } else {
        await showcase.Floor.moveTo(floorIndex);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const moveToMPLabels = async (menu: TMenuObject) => {
    const { type, labelId, floorId } = menu;
    const THREE = await ThreeInstance.get();

    try {
      switch (type) {
        case MenuType.MatterportFloor:
          // ToDo: menu.floorId from old API so we can not be sure that it work constantly
          const floorIndex = mpFloors.findIndex((l) => String(l.id) === String(floorId));
          await changeViewMode(TourMode.FLOORPLAN);
          await changeFloor(floorIndex);
          break;
        case MenuType.MatterportLabel:
          const label = mpLabels.find((l) => l.sid === labelId);
          if (!label) console.error('Label not found');
          const sweepsOnFloor = sweeps.filter(
            (x) => x.floorInfo.id === label.floorInfo.id && x.enabled,
          );

          if (sweepsOnFloor.length === 0) console.error('Sweeps not found');

          const startPoint = new THREE.Vector3(
            label.position.x,
            label.position.y,
            label.position.z,
          );
          const distances = sweepsOnFloor.map((sweep) => {
            const endPoint = new THREE.Vector3(
              sweep.position.x,
              sweep.position.y,
              sweep.position.z,
            );
            const distance = Math.abs(startPoint.distanceTo(endPoint));
            return {
              distance,
              ...sweep,
            };
          });

          const sweepsWithMinDistance = distances.reduce((a, b) =>
            a?.distance <= b?.distance ? a : b,
          );
          // eslint-disable-next-line dot-notation, @typescript-eslint/dot-notation
          await showcase.Sweep.moveTo(sweepsWithMinDistance['id'], {
            // eslint-disable-next-line dot-notation, @typescript-eslint/dot-notation
            rotation: sweepsWithMinDistance['rotation'],
            transition: showcase.Mode.TransitionType.FLY,
          });
          break;
        default:
          console.error('moveToMPLabels: Menu type unknown');
          break;
      }
    } catch (e) {
      console.error(e);
    }
  };

  const moveToMenuItem = (menu: TMenuObject) => {
    if (menu.type === MenuType.MatterportLabel || menu.type === MenuType.MatterportFloor) {
      moveToMPLabels(menu);
    } else {
      loadModel(menu);
    }
    if (isHorizontalMobileView) {
      resetMenus(menuState.menus);
    }
  };

  const toggleNav = () => {
    setMenuState((prevState) => ({
      ...prevState,
      menuOpen: menuOpenForDevice || !prevState.menuOpen,
      menuOpened: true,
      activeMenu: null,
      MenuHintOn: false,
    }));
  };

  const onChangeSearch = ({ target }) => {
    const searchStr = target.value.toLowerCase();
    setMenuState((prevState) => ({
      ...prevState,
      menus: filterMenuItems(menuState.originMenus, searchStr),
    }));
  };

  const clearSearch = () => {
    onChangeSearch({ target: { value: '' } });
  };

  return (
    <>
      <ButtonBg
        menuOpen={menuState.menuOpen}
        chatToken={chatToken}
        tour={tour}
        host={host}
        menuOpenForDevice={menuOpenForDevice}
        tourType={tourType}
        MenuHintOn={menuState.MenuHintOn}
        translation={translation}
        showExpand={!menuState.menuOpened && !menuState.menuOnStart}
        tourEmail={tourEmail}
        showCustomButton={showCustomButton}
        getInTouchHintOn={getInTouchHintOn}
        toggleContactPopup={toggleContactPopup}
        appointmentsHintOn={appointmentsHintOn}
        toggleAppointmentsModal={toggleAppointmentsModal}
        handleCustomButton={handleCustomButton}
        toggleNav={toggleNav}
        openOnHover={openOnHover}
        menu={menu}
        menuColors={menuColors}
      />
      <Box
        component="nav"
        sx={NavStyle(menuState.menuOpen, menuColors?.fon)}
        className={classNames(
          rtl && 'rtl',
          isHorizontalMobileView && 'horizontal-modile-menu-view',
        )}
      >
        {bookUrl && bookText && (
          <Link
            id="book"
            rel="noreferrer"
            target="_blank"
            href={bookUrl}
            sx={{
              ...ButtonCommonStyle,
              backgroundColor: buttonColors.passive || whitelabel?.primaryColor,
              color: buttonColors.text || '#fff',
              '&:hover': {
                backgroundColor:
                  buttonColors.active ||
                  whitelabel?.secondaryColor ||
                  'var(--color-secondary) !important',
              },
            }}
          >
            {bookText}
          </Link>
        )}
        {menuSearch && (
          <TextField
            type="text"
            onChange={onChangeSearch}
            placeholder={(translation && translation.searchMenu) || 'Search...'}
            ref={inputSearchRef}
            sx={{
              marginLeft: '25px',
              marginBottom: '30px',
              paddingRight: '40px',
              borderRadius: '7px',
              height: '40px',
              width: '250px',
              position: 'relative',
            }}
            InputProps={{
              style: SearchInputStyle,
              endAdornment: (
                <>
                  <Icon type="fas" icon="faTimes" onClick={clearSearch} sx={CloseButtonStyle} />
                  <Stack
                    justifyContent="center"
                    alignItems="center"
                    sx={SearchButtonStyle(
                      menuColors?.searchButtonColor || whitelabel?.secondaryColor,
                    )}
                  >
                    <Icon type="fas" icon="fa-search" size="small" />
                  </Stack>
                </>
              ),
            }}
          />
        )}
        <Typography variant="h2" sx={MenuGeaderStyle(menuColors?.text)}>
          {translation && translation.menu}
        </Typography>

        {!isHorizontalMobileView ? (
          <MenuNav
            menus={menuState.menus}
            rtl={rtl}
            openMenu={openMenu}
            loadModel={moveToMenuItem}
            menuRef={menuRef}
            menuColors={menuColors}
            whitelabel={whitelabel}
          />
        ) : (
          <LeftMenuNav
            menus={menuState.menus}
            openMenu={openMenu}
            loadModel={moveToMenuItem}
            menuRef={menuRef}
            menuColors={menuColors}
          />
        )}
        {bookAppointment && (
          <Box sx={ButtonCommonStyle} onClick={toggleAppointmentsModal}>
            <Icon mr={2} icon="fa-calendar-alt" />
            {translation && translation.bookAppointment}
          </Box>
        )}
        {contact && (
          <Box
            sx={{
              ...ButtonCommonStyle,
              backgroundColor: buttonColors.passive || whitelabel?.primaryColor,
              color: buttonColors.text || '#fff',
              '&:hover': {
                backgroundColor:
                  buttonColors.active ||
                  whitelabel?.secondaryColor ||
                  'var(--color-secondary) !important',
              },
            }}
            onClick={toggleContactPopup}
          >
            <Icon mr={2} type="fas" icon="fa-mobile" />
            {translation && translation.getInTouch}
          </Box>
        )}
        <Box
          sx={{
            textAlign: 'left',
            padding: '0 25px',
            position: 'relative',
            width: '100%',
            margin: '20px 0',
            img: {
              height: '30px',
              marginLeft: '10px',
              verticalAlign: 'middle',
            },
          }}
        >
          {address && (
            <Box component="span" onClick={toggleAddressPopup} sx={AddressBoxStyle}>
              <Icon type="fas" icon="fa-map-marker-alt" />
              {address}
            </Box>
          )}
          <Typography variant="h5" textAlign="center" color="#fff" display="block" fontSize="12px">
            {translation && translation.producedBy}{' '}
            <a rel="noreferrer" target="_blank" href={whitelabel?.website}>
              <img src={whitelabel?.logo} alt="" />
            </a>
          </Typography>
        </Box>
      </Box>
      <ExternalPopup
        show={!!popUp.externalPopupUrl && popUp.externalPopupOn}
        url={popUp.externalPopupUrl}
        onClose={() => toggleExternalPopup(popUp.externalPopupUrl)}
        width={fromAdmin ? 75 : 90}
        height={fromAdmin ? 75 : 90}
        windowWidth={windowWidth}
        {...(popUp.iframeSettings &&
          Object.keys(popUp.iframeSettings).length && { iframeSettings: popUp.iframeSettings })}
      />
      {panorama.panoramaOn && panoramas.length > 0 && tour && (
        <Panorama
          panoramas={panoramas}
          awsUrl={awsUrl}
          markMinimap={() => {}}
          panoPose={{ yaw: 0, pitch: 0, hfov: 0 }}
          activePano={panorama.activePano}
          transition={tour.panoramaTransition}
          // isChatGuest={room && socket && socket.connected && !host}
          defaultPanorama={tour.defaultPanorama}
          updatePanoRotation={() => {}}
          openHotspot={() => {}}
          onSceneChange={() => {}}
        />
      )}
    </>
  );
};
